function roundWithPrecision(value: number, precision: number = 2): number {
  const factor = Math.pow(10, precision);
  // Add a small epsilon to handle floating point precision issues
  const epsilon = Number.EPSILON * Math.abs(value * factor);
  return (
    Math.round(value * factor + (value >= 0 ? epsilon : -epsilon)) / factor
  );
}
export { roundWithPrecision };
